import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { AuthenticatedLayout } from "@/layouts/AuthenticatedLayout/AuthenticatedLayout";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { Button } from "@/modules/theme/components/Button/Button";
import { PageMeta } from "@/modules/theme/components/PageMeta";

import { Base404NotFoundLayout } from "./Base404NotFoundLayout";

const translationNamespace = "pages/AuthenticatedNotFoundPage";

export function AuthenticatedNotFoundPage() {
  const { t } = useTranslation(translationNamespace);
  const history = useHistory();

  const classes = {
    root: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: 0,
    }),
  };

  return (
    <AuthenticatedLayout containerClassName={classes.root}>
      <PageMeta title={t("Not Found")} />
      <Base404NotFoundLayout>
        <Button
          onClick={() => history.push(authenticatedRouting.buildUrl("tasks"))}
        >
          {t("Back to Tasks")}
        </Button>
      </Base404NotFoundLayout>
    </AuthenticatedLayout>
  );
}
